import { AbstractControl, ValidationErrors } from "@angular/forms";
import * as moment from 'moment';
import { IValidator } from "../../forms/utils/validators/IValidator";
import { AbstractValidator } from "../../forms/utils/validators/AbstractValidator";
import { Yii } from "libraries/interfaces/Yii";
import { IAgeLimitDefault, IAgeLimitConfig } from "./age-limit-config.interface";
import { AirTravellerType } from "libraries/service/resources/model/booking/air/IAirTraveller";

export class IsCorrectDateForType extends AbstractValidator implements IValidator {

    public constructor(private readonly config: IAgeLimitDefault, private readonly typeControl: AbstractControl) {
        super({
            isTooOldForType: {
                when: 'touched',
                class: 'form-error-date',
                message: Yii.t('wui-shared-js', "Le voyageur est trop âgé pour le type sélectionné"),
            },
            isTooYoungForType: {
                when: 'touched',
                class: 'form-error-date',
                message: Yii.t('wui-shared-js', "Le voyageur est trop jeune pour le type sélectionné"),
            },
        });
    }

    public validate(control: AbstractControl): ValidationErrors | null {
        if (!control.value) {
            return null;
        }

        const birthDate: moment.Moment = moment(control.value);

        const rule: IAgeLimitConfig = this.typeControl.value === AirTravellerType.Infant.toString()
            ? this.config.Infant
            : this.typeControl.value === AirTravellerType.Child.toString()
                ? this.config.Child
                : this.config.Adult;

        if (birthDate.isAfter(rule.max)) {
            return { isTooYoungForType: true };
        }

        if (birthDate.isBefore(rule.min)) {
            return { isTooOldForType: true };
        }

        return null;
    }
}
